@if (organisation) {
    <a target="_blank"
       [attr.href]="href">{{ organisation.urlIdentifier }}</a>
}
